export const LANGUAGE = {
    en: 'en-US',
    ph: 'en-PH',
    id: 'id-ID'
}
export const LIST_TYPE = { // 接口查询列表类型
    "INDEX_BANNER": "INDEX_BANNER", // 首页轮播
    "INDEX_GRID": "INDEX_GRID", // 首页列表
    "SEARCH_RECOMMEND": "SEARCH_RECOMMEND" // 商品搜索推荐
}

export const AGREEMENT_SCENE = { // 协议场景
    "REGISTER": "REGISTER", // 注册
    "PLACE_ORDER": "PLACE_ORDER", // 下单
    "KYC": "KYC", // KYC
    "ADDITIONAL_INFO": "ADDITIONAL_INFO", // 补充资料
}

export const RENTAL_CYCLE_DAYS = {
    "WEEKLY": 7,
    "BI_WEEKLY": 14,
    "MONTHLY": 28
}

export const PAY_METHOD = {
    "ONLINE": "ONLINE",
    "COD": "COD",
    "STORE": "STORE"
}

export const isCodOrder = (orderDetail = {}) => orderDetail?.payMethod === PAY_METHOD.COD
export const isStoreOrder = (orderDetail = {}) => orderDetail?.payMethod === PAY_METHOD.STORE

export const ORDER_STATUS = {
    "PAYMENT": 'PENDING_PAYMENT',  // 待付款
    "DELIVERY": 'PENDING_DELIVERY', // 待发货
    "LOGISTICS": 'PENDING_LOGISTICS', // 待上传物流
    "RECEIVE": 'PENDING_RECEIVE',  // 待收货
    "RETURN": 'PENDING_RETURN',   // 待归还
    "BREACH": 'BREACH',           // 毁约
    "SUCCESS": 'SUCCESS',          // 成功
    "CLOSED": 'CLOSED',           // 关闭
    "CANCELLED":"CANCELLED",      //取消
}
export const BREACH_ORDER_STATUS = { // 毁约订单状态枚举
    "PROCESSING": 'PROCESSING', // 退租处理中
    "COMPLETED": 'COMPLETED', // 退租已完成
}

export const PAYMENT_STATUS = { // 支付状态枚举
    "CREATED": 'CREATED',
    "PAYING": 'PAYING',
    "SUCCESS": 'SUCCESS',
    "FAILED": 'FAILED',
    "CLOSED": 'CLOSED'
}

export const PAYMENT_BILLS_I18N = { // 账单类型枚举
    "DEPOSIT": 'payment.deposit',
    "RENT": 'payment.rent',
    "INSURANCE": 'payment.insurance',
    "PENALTY": 'payment.penalty',
    "RETURN_DAMAGE": 'payment.return_damage',
}

export const REPAY_LIST_STATUS = {  // 还款列表状态枚举
    "PENDING": 'PENDING', // 待还款
    "SETTLED": 'SETTLED', // 已还款
    "OVERDUE": 'OVERDUE', // 已逾期
    "FROZEN": 'FROZEN', // 已冻结
    "CANCELLED": 'CANCELLED', // 已毁约
}

export const RENTAL_PLAN_STATUS = {  // 还款计划状态枚举
    "PENDING": 'PENDING', // 待还款
    "SETTLED": 'SETTLED', // 已还款
    "OVERDUE": 'OVERDUE', // 已逾期
    "FROZEN": 'FROZEN', // 已冻结
    "CANCELLED": 'CANCELLED', // 已毁约
}
export const BREACH_STATUS = {  // 毁约状态枚举
    "NORMAL": 'normal', // 正常(还未毁约)
    "SUBMIT": 'SUBMIT', // 已提交
    "APPROVED": 'APPROVED', // 已审批
    "REJECT": 'REJECT', // 审批拒绝
    "PAID": 'PAID', // 已支付违约金
    "LOCKED_DEVICE": 'LOCKED_DEVICE', // 已锁机  该状态不在状态机中
    "SUBMIT_TRACKING": 'SUBMIT_TRACKING', // 退机已收货
    "ACCEPT_TRACKING": 'ACCEPT_TRACKING', // 已接收物流
    "CHECKED_DEVICE": 'CHECKED_DEVICE', // 已验机
    "DEPOSIT_REFUND": 'DEPOSIT_REFUND', // 已退押金
    "COMPLETED": 'COMPLETED', // 已完成
}

export const SHIPPING_COMPANY = [
    { text: 'J&T Express', value: 100074 },
    { text: 'ID Express', value: 100511 },
    { text: 'JNE Express', value: 100086 },
]

export const CARRIERS =  [
  {
    "key": 100074,
    "name": "J&T Express",
    "sort": 1,
    "isFrequent": true
  },
  {
    "key": 100511,
    "name": "ID Express",
    "sort": 8,
    "isFrequent": true
  },
  {
    "key": 100086,
    "name": "JNE Express",
    "sort": 9,
    "isFrequent": true
  },
  {
    "key": 100588,
    "name": "TIKI",
    "sort": 10,
    "isFrequent": true
  },
  {
    "key": 100344,
    "name": "SAP Express",
    "sort": 20,
    "isFrequent": true
  },
  {
    "key": 100600,
    "name": "Dakota Cargo",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 100125,
    "name": "Ninja Xpress",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 100591,
    "name": "Paxel",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 101343,
    "name": "GTI Translogistics",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 101031,
    "name": "Sentral Cargo",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 100590,
    "name": "SiCepat Ekspres",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 100587,
    "name": "REX",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 100589,
    "name": "AnterAja",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 100906,
    "name": "Pandu Logistics",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 9031,
    "name": "Pos Indonesia",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 100409,
    "name": "SiCepat Express",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 100586,
    "name": "Lion Parcel",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 100228,
    "name": "JDL Express",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 100585,
    "name": "Tokopedia",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 100470,
    "name": "Tongtu Express",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 100183,
    "name": "Wahana Prestasi Logistik",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 101148,
    "name": "Kerry Express",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 101314,
    "name": "Lazada eLogistics",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 100643,
    "name": "PCP Express",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 100660,
    "name": "Kurasi",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 100778,
    "name": "J&T Cargo",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 100904,
    "name": "Indah Logistik",
    "sort": 999999,
    "isFrequent": false
  },
  {
    "key": 101329,
    "name": "AnterAja",
    "sort": 999999,
    "isFrequent": false
  }
]

export const RELATIONSHIP_TYPE = [
    { textPh: 'Mga Magulang', textEn: 'Parents', textId: 'Orang Tua', value: 'PARENTS' },
    { textPh: 'Mga Kapatid', textEn: 'Siblings', textId: 'Saudara Kandung', value: 'SIBLINGS' },
    { textPh: 'Asawa', textEn: 'Spouse', textId: 'Pasangan', value: 'SPOUSE' },
    { textPh: 'Anak', textEn: 'Child', textId: 'Anak', value: 'CHILD' },
    { textPh: 'Kaibigan', textEn: 'Friend', textId: 'Teman', value: 'FRIEND' },
    { textPh: 'Kasamahan sa Trabaho', textEn: 'Colleague', textId: 'Rekan Kerja', value: 'COLLEAGUE' },
    { textPh: 'Tito/Tita', textEn: 'Uncle/Aunt', textId: 'Paman/Bibi', value: 'UNCLE_AUNT' },
    { textPh: 'Lolo/Lola', textEn: 'Grandparent', textId: 'Kakek/Nenek', value: 'GRANDPARENT' },
    { textPh: 'Lba Pa', textEn: 'Other', textId: 'Lainnya', value: 'OTHER' },

]
